import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DropdownDictionary} from '@secca/shared/models/dropdownDictionary';
import {
  CaseDocumentTagEnum,
  InputType,
  InputTypePattern,
  RecoveryStatus,
  RecoveryStatusIndex,
  SalesOrderItemTypeEnum,
  ValidationTypeEnum,
  recoveryModalType
} from '@secca/shared/models/enums';
import {ServiceOrder} from '@secca/shared/models/service-order/service-order';
import {PermissionService} from '@secca/core/services/permission.service';
import {TranslateService} from '@ngx-translate/core';
import {CaseService} from '@secca/core/services/case.service';
import {AutoCompleteTypeEnum} from '@secca/shared/components/drop-down-countries-auto-complete/auto-complete-type-enum';
import {DictionaryService} from '@secca/core/services/dictionary.service';
import moment from 'moment-timezone';
import * as _ from 'lodash';
import {CaseMessageService} from '@secca/core/services/case-message.service';
import {OutputManagementService} from '@secca/case/components/case-output-management/services/output-management.service';
import {ModalDialogComponent} from '@secca/shared/components/modal-dialog/modal-dialog.component';
import {ModalDialogConfiguration} from '@secca/shared/models/modal/modal-dialog-configuration';
import {DialogViewerServiceInterface} from '@secca/core/services/dialog-viewer-service-interface';
import {DIALOG_VIEWER_TOKEN} from '@secca/core/services/token';
import {CaseValidationService} from '@secca/core/services/case-validation.service';
import {EconomyStatusBarValues} from '@secca/shared/models/economyStatusBarValues';
import {CaseLockHelperService} from '@secca/core/services/case-lock-helper.service';
import {CaseLockOverlayAction, LockContextEnum} from '@secca/shared/enums/lock-context.enum';
import {finalize, switchMap, tap} from 'rxjs/operators';
import {CaseStateService} from '@secca/core/state-services/case-state.service';
import {MasterListService} from '@secca/core/services/masterlist-service';
import {SupplierInvoiceService} from '@secca/core/services/supplier-invoice.service';
import {Case} from '@secca/shared/models/case';
import {FinancialStatusService} from '@secca/core/services/financial-status.service';
import { Recovery, RecoveryTypeEnum } from '@secca/shared/models/recovery';
import { RecoveryService } from '@secca/core/services/recovery.service';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { RecoveryDocumentComponent } from '../recovery-document/recovery-document.component';
import { SalesOrderService } from '@secca/core/services/sales-order.service';
import { SalesOrder } from '@secca/shared/models/salesOrder';
import { SupplierInvoice } from '@secca/shared/models/supplierInvoice';
import { RecoveryViewItem, RecoveryViewItemType } from '@secca/shared/models/recovery-view-Item';
import { forkJoin, Observable, map } from 'rxjs';
import { InvoiceItemEvent, RemittanceItemEvent } from '../recovery-item/recovery-item.component';
import { PlanService } from '@secca/core/services/plan.service';
import { BillingCurrency } from '@secca/shared/models/billing-currency';
import { SalesOrderStatus } from '@secca/shared/enums/sales-order-status';
import { DocumentService } from '@secca/core/services/document.service';
import { CaseDocument } from '@secca/shared/models/caseDocument';
import { DateSerializer } from '@secca/shared/models/date-serializer';
import { ReasonForCancellation } from '@secca/shared/models/reason-for-cancellation';
import { RecoveryPaymentService } from '@secca/core/services/recovery/recovery-payment.service';
import { ProfileService } from '@secca/core/services/profile.service';
import { RecoveryTypes } from '@secca/shared/models/recoveryTypes';
import { RefundService } from '@secca/core/services/refund.service';
import { Refund } from '@secca/shared/models/refund';
import { ServiceItemType } from '@secca/shared/models/service-item-type';
import { ReductionsCalculator } from '@secca/case/components/case-economy/case-economy-add-claims-dialog/refund-item/reduction-calculator';
import { ServiceOrderService } from '@secca/core/services/service-order.service';
import { RecoveryPaymentUtils } from '@secca/shared/utils/recovery-payment-utils';

@Component({
    selector: 'app-add-recovery',
    templateUrl: './add-recovery.component.html',
    styleUrls: ['./add-recovery.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddRecoveryComponent implements OnInit {
  @Input() readOnly: boolean;
  @Input() caseCreatedDate: Date;
  @Input() customerProfileId: string;
  @Input() caseId: string;
  @Input() recoveryId: string;
  @Input() recoveryType: RecoveryTypes;
  @Input() incidentDate: moment.Moment;
  @Output() closed = new EventEmitter<number>();
  @Output() update = new EventEmitter<number>();
  @Output() recoveryDeleted = new EventEmitter<number>();

  @ViewChild(RecoveryDocumentComponent) recoveryDocumentComponent: RecoveryDocumentComponent;

  currencyMaskOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 2,
    allowNegative: true,
    inputMode: NgxCurrencyInputMode.Natural,
  };

  recovery: Recovery;
  oldRecovery: Recovery;
  recoveryItems: RecoveryViewItem[];
  invoiceNumbers: DropdownDictionary[] = [];
  remittanceAdvices: DropdownDictionary[] = [];
  serviceOrdersForRecovery: ServiceOrder[];
  serviceItemsForRecovery: any[];
  serviceItemsForRefund: ServiceItemType[];
  salesOrders: SalesOrder[];
  supplierInvoices: SupplierInvoice[];
  refunds: Refund[];
  remittanceDocuments: CaseDocument[];
  currentCase: Case;
  storingRecovery = false;
  nationalHealthAuthority: string;
  isCaseErpReady = false;
  groupMemberValid = true;
  calculateTotalRecoveryCurrency: number;
  recoveryState = new RecoveryState();
  waitBeforeInitTextbox = false;
  paymentsApprovedOrFinalized = false;
  recoveryToday: Date;
  reasonsForCancellationFilteredByRecoveryType: ReasonForCancellation[] = [];
  activeReasonsForCancellationOnCreationDate: DropdownDictionary[] = [];
  activeReasonsForCancellation: DropdownDictionary[] = [];
  reasonForCancellation: string;
  billingCurrency: BillingCurrency;
  selectableInvoiceNumbers = {};
  numberOfStatus = 6;
  numberOfStatusNonEUHealthcase = 4;
  showSpinner = false;
  recoveryWithNoItems: boolean = false;
  profileMarket: string;
  private reductionsCalculator: ReductionsCalculator;
  itemTypes = new Map<string, string>();
  recoveryTypeText: string;

  constructor(private modalService: NgbModal,
              private recoveryService: RecoveryService,
              private recoveryPaymentService: RecoveryPaymentService,
              public permissionService: PermissionService,
              private masterListService: MasterListService,
              private translateService: TranslateService,
              private salesOrderService: SalesOrderService,
              private supplierInvoiceService: SupplierInvoiceService,
              private caseService: CaseService,
              private dictionaryService: DictionaryService,
              private caseMessageService: CaseMessageService,
              private outputManagementService: OutputManagementService,
              private caseValidationService: CaseValidationService,
              private planService: PlanService,
              private documentService: DocumentService,
              public caseLockHelperService: CaseLockHelperService,
              public caseStateService: CaseStateService,
              public financialStatusService: FinancialStatusService,
              private refundService: RefundService,
              @Inject(DIALOG_VIEWER_TOKEN) private dialogViewerService: DialogViewerServiceInterface,
              private profileService: ProfileService,
              private serviceOrderService: ServiceOrderService
            ) {
              this.reductionsCalculator = new ReductionsCalculator();
  }

  ngOnInit(): void {
    if (this.customerProfileId){
      this.validateCustomerProfile();
    }

    const [documentTagName] = Object.entries(CaseDocumentTagEnum).find(([key, value]) => value === CaseDocumentTagEnum.REMITTANCE_ADVICE);


    forkJoin({
      serviceOrdersForRecovery: this.recoveryService.getServiceOrdersForRecovery(+this.caseId),
      serviceItems: this.recoveryService.getServiceItemList(),
      payments: this.recoveryPaymentService.getRecoveryPaymentByCaseId(+this.caseId),
      salesOrders: this.salesOrderService.getSalesOrdersByCaseId(this.caseId),
      supplierInvoices: this.supplierInvoiceService.getSupplierInvoicesByCase(+this.caseId),
      remittanceDocuments: this.documentService.getDocumentsByDocumentTag(+this.caseId, documentTagName),
      recovery: this.getRecovery(this.recoveryId),
      refund: this.refundService.getRefundByCaseId(+this.caseId),
    }).subscribe(({serviceOrdersForRecovery, serviceItems, payments, salesOrders, supplierInvoices, remittanceDocuments, recovery, refund}) => {
      this.serviceOrdersForRecovery = serviceOrdersForRecovery;
      this.serviceItemsForRefund = serviceItems;
      this.serviceItemsForRecovery = serviceItems?.filter(item => item.recovery);
      this.paymentsApprovedOrFinalized = RecoveryPaymentUtils.isPaymentsApprovedOrFinalized(payments, recovery);
      this.salesOrders = salesOrders;
      this.supplierInvoices = supplierInvoices;
      this.remittanceDocuments = remittanceDocuments;
      this.recovery = recovery;
      this.refunds = refund;

      this.caseService.getCase('' + this.caseId).pipe(
      switchMap(resultCase => {
        this.currentCase = resultCase;
        return this.initialiseReasonForCancellation(resultCase.caseCreatedDateAsISOString);
      })
      )
      .subscribe();

      this.refunds.forEach(refund => {
        this.itemTypes.set(refund.id.toString(), RecoveryViewItemType.REFUND);
      });
      this.supplierInvoices.forEach(supplierInvoice => {
        this.itemTypes.set(supplierInvoice.invoiceNumber, RecoveryViewItemType.SUPPLIER_INVOICE);
      });

      this.masterListService.getAllRecoveryTypes().subscribe(result => {
        this.recoveryTypeText = result.find(item => item.businessKey === this.recoveryType?.businessKey)?.name;
      });

      if(this.recovery.recoveryType != RecoveryTypeEnum.RT01) {
        this.serviceOrderService.getServiceOrdersForCase(+this.caseId).subscribe( allServiceOrders => {
          this.serviceOrdersForRecovery = allServiceOrders;
        });
      }

      this.recovery.recoveryType = this.recoveryType?.businessKey as RecoveryTypeEnum;
      if(!this.recovery.id) {
        switch (this.recovery.recoveryType) {
          case RecoveryTypeEnum.RT02:
            if(this.incidentDate) {
              this.recovery.applicationDeadline = moment(this.incidentDate).add(3, 'years');
            }
            this.recovery.dueDate =  moment().add(30, 'days');
            break
          case RecoveryTypeEnum.RT03:
            this.recovery.applicationDeadline = moment(this.caseCreatedDate).add(2, 'days');
            this.recovery.dueDate =  moment().add(30, 'days');
            break
          default:
            break;
        }
      }

      this.initialise();
          });
  }

  deleteRecoveryItem(event: InvoiceItemEvent) {
    if ( this.isRecoveryDisabled() || this.isApplicationSent() ) {
      return;
    }
    this.recoveryItems.splice(event.itemIndex, this.invoiceItemsCount(event.itemIndex));
    this.selectableInvoiceNumbers = {};
    this.onRecoveryItemChange();
  }

  close() {
    this.closed.emit();
    this.modalService.dismissAll();
  }

  addRecoveryItem() {
    if ( this.isRecoveryDisabled() || this.isApplicationSent() ) {
      return;
    }

    this.recoveryItems.push(this.createRecoveryItem());
    this.onRecoveryItemChange();
  }

  requestInformationActiveStatus() {
    return false;
  }

  showDeleteButton() {
    return true;
  }

  showDeniedButton() {
    return true;
  }

  isCancelButtonDisabled() {
    return !this.recovery.reasonForCancellation || this.isRecoveryDisabled();
  }

  isCancelReasonDisabled() {
    return !this.recovery.id;
  }

  isCancelled() {
    return this.recovery?.recoveryStatus === RecoveryStatus.CANCELLED;
  }

  isDenied() {
    return this.recovery?.recoveryStatus === RecoveryStatus.DENIED;
  }

  isRecoveryDisabled() {
    return this.isCancelled() || this.readOnly || this.storingRecovery ||
      this.caseLockHelperService.isCaseBasicLockTaken || this.caseStateService.isCaseClosed || this.isDenied();
  }

  itemsDeleteable(): boolean {
    if(this.recoveryItems) {
      return this.recoveryItems.length > 1 ? true : false;
    } else{
      return false
    }
  }

  isSaveButtonDisabled() {
    if ( !this.recoveryState.recoveryContextValid ) {
      return true;
    }
    return !this.recoveryChanged();
  }

  isDeleteButtonDisabled() {
    return !this.recovery.id || this.isApplicationSent();
  }

  isDeniedButtonDisabled() {
    return !(this.recovery?.recoveryStatus === RecoveryStatus.APPLICATION_SENT
      || this.recovery?.recoveryStatus === RecoveryStatus.APPLICATION_FOLLOW_UP);
  }

  isPOAReceivedButtonDisabled() {
    return !this.recoveryState.validForReceived;
  }

  isPreviewApplicationButtonDisabled() {
    if (this.recovery.recoveryType === RecoveryTypeEnum.RT01) {
      return !this.recoveryState.validForPreviewApplication || !this.isAllSelectedInvoicesCharged() || this.recoveryState.applicationHasBeenPreviewed || !this.recovery.id;
    } else {
      return !this.recoveryState.validForPreviewApplication ||  this.recoveryState.applicationHasBeenPreviewed || !this.recovery.id;
    }
  }

  isSendApplicationButtonDisabled() {
    if (this.recovery.recoveryType === RecoveryTypeEnum.RT01) {
      return !this.recoveryState.validForSendApplication || !this.isAllSelectedInvoicesCharged() || this.missingMandatoryApplicationFields();
    }
    else if (this.recovery.recoveryType === RecoveryTypeEnum.RT03) {
      return (this.recoveryId === null);
    } else {
      return (this.recoveryId === null || !this.recoveryState.applicationHasBeenPreviewed);
    }
  }

  isSaveApplicationButtonDisabled() {
    return !this.recoveryState.validToSaveApplication || !this.isAllSelectedInvoicesCharged() || this.missingMandatoryApplicationFields();
  }

  isApplicationSent() {
    return !this.recoveryWithPaymentInAS400AndNoItens() ? RecoveryStatus.SEND_APPLICATION != this.recovery.recoveryStatus
      && this.getStatusIndexByStatus(this.recovery.recoveryStatus, this.recovery.recoveryType).statusIndex >= RecoveryStatusIndex.APPLICATION_SENT : false;
  }

  recoveryWithPaymentInAS400AndNoItens(): boolean  {
    return this.recoveryWithNoItems && (this.recovery.recoveryStatus === RecoveryStatus.PAYMENT_IN_AS400 || this.recovery.recoveryStatus === RecoveryStatus.APPLICATION_SENT);
  }

  focusElement(event: any) {
    event.target.select();
  }

  onRecoveryItemChange() {
    this.recoveryState.applicationHasBeenPreviewed = false;
    this.recalculateRecoveryState();
  }

  getItemType(itemNumber: string): string {
    return this.itemTypes.get(itemNumber);
  }

  // STAR: change invoice dropdown
  onInvoiceNumberChange(event: InvoiceItemEvent) {
    const invoiceNo = event.invoiceNumber;
    const itemType = this.itemTypes.get(invoiceNo.toString());
    const recoveryItems = itemType == RecoveryViewItemType.SUPPLIER_INVOICE ? this.getRecoveryItemsByInvoiceNumber(invoiceNo) : this.getRecoveryItemsByRefundNumber(invoiceNo);

    if ( !!recoveryItems ) {
      this.recoveryItems.splice(event.itemIndex, this.invoiceItemsCount(event.itemIndex), ...recoveryItems);
    }

    this.recalculateRecoveryState();
    this.selectableInvoiceNumbers = {};
  }

  onRemittanceAdviceChange(event: RemittanceItemEvent) {
    this.recoveryItems
      .filter(ri => ri.supplierInvoiceNumber === event.invoiceNumber)
      .forEach(item => item.remittanceAdviceDocumentId = event.remittanceAdviceDocumentId);

    this.recalculateRecoveryState();
  }

  totalAppliedAmount() {
    let totalAmount = 0;
    this.recoveryItems.forEach((item: RecoveryViewItem) => {
      totalAmount += item.isInvoiceItemIncluded ? item.appliedAmount : 0;
    });
    return totalAmount;
  }

  totalRecoveredAmount() {
    let totalAmount = 0;
    this.recoveryItems.forEach((item: RecoveryViewItem) => {
      totalAmount += item.isInvoiceItemIncluded ? item.recoveredAmount : 0;
    });
    return totalAmount;
  }

  recoveredProcent() {
    const totalAppliedAmount = this.totalAppliedAmount();
    const totalRecoveredAmount = this.totalRecoveredAmount();
    return totalAppliedAmount !== 0 ? totalRecoveredAmount * 100 / totalAppliedAmount : 0;
  }

  swedishOrFinnishRecovery(): boolean {
    return this.profileMarket === 'FI' || this.profileMarket === 'SE';
  }

  recalculateRecoveryState(): RecoveryState {
    const recoveryStatusIndex = this.getStatusValues(this.recovery).statusIndex;
    this.recoveryState.recoveryContextValid = !!this.recovery.dueDate && !!this.recovery.applicationDeadline;
    this.recoveryState.recoveryItemsValid = this.recoveryItems.filter(item =>
      !!item.supplierInvoiceNumber ? (!this.swedishOrFinnishRecovery() && this.recovery.recoveryType == RecoveryTypeEnum.RT01 ? !item.supplierInvoiceNumber || !item.remittanceAdviceDocumentId : !item.supplierInvoiceNumber)
      : !item.refundNumber
    )?.length === 0;
    this.recoveryState.recoveryValid = this.recoveryState.recoveryContextValid
      && this.recoveryState.recoveryItemsValid
      && this.totalAppliedAmount() > 0;
    this.recoveryState.validForReceived = this.recoveryState.recoveryContextValid
      && recoveryStatusIndex < RecoveryStatusIndex.POA_SIGNED;
    this.recoveryState.validForPreviewApplication = this.recoveryState.recoveryValid
      && this.recovery.description?.length > 0
      && !!this.recovery.templateId && !!this.recovery.templateLanguage
      && [RecoveryStatus.POA_SIGNED, RecoveryStatus.SEND_APPLICATION].includes(this.recovery.recoveryStatus);
    this.recoveryState.validForSendApplication = this.recoveryState.recoveryValid
      && this.recoveryState.validForPreviewApplication
      && this.recoveryState.applicationHasBeenPreviewed;
    this.recoveryState.validToSaveApplication = this.recoveryState.validForSendApplication;
    return this.recoveryState;
  }

  lockRecoveryOnApproved(): boolean {
    return [RecoveryStatus.SETTLED].includes(this.recovery?.recoveryStatus);
  }

  receivedPOA() {
    this.recovery.recoveryStatus = RecoveryStatus.POA_SIGNED;
    this.saveAndClose();
  }

  applicationSent() {
    this.recovery.recoveryStatus = RecoveryStatus.APPLICATION_SENT;
    this.saveAndClose();
  }

  previewApplication() {
    this.showSpinner = true;
    this.save().pipe(
      switchMap(() => this.recoveryDocumentComponent.preview()),
      finalize(() => this.showSpinner = false),
    ).subscribe();
  }

  applicationHasBeenPreviewed() {
    this.recoveryState.applicationHasBeenPreviewed = true;
    this.showSpinner = false;
    this.recalculateRecoveryState();
  }

  sendApplication() {
    this.showSpinner = true;
    this.save().pipe(
      switchMap(() => this.recoveryDocumentComponent.send()),
      finalize(() => this.showSpinner = false)
    )
    .subscribe();
  }

  saveApplication(close: boolean = true) {
    if (this.recovery.recoveryStatus !== RecoveryStatus.SEND_APPLICATION) {
      this.recovery.recoveryStatus = RecoveryStatus.SEND_APPLICATION;
    }
    this.showSpinner = true;
    this.save().pipe(
      switchMap(() => this.recoveryDocumentComponent.save()),
      tap(() => {
        if (close) {
          this.close();
        }
      }),
      finalize(() => this.showSpinner = false)
    ).subscribe();
  }

  saveAndClose(close: boolean = true){
    if (this.storingRecovery) {
      return;
    }
    this.save().pipe(
      tap(() => {
        if (close) {
          this.close();
        }
      })
    )
    .subscribe();
  }

  deleteRecovery() {
    if ( this.isDeleteButtonDisabled() ) {
      return;
    }
    const modalRef = this.showDeleteRecoveryWarningMessageDialog();
    modalRef.componentInstance.closeModalEvent.subscribe(closedClickingYes => {
        if (closedClickingYes) {
          this.recoveryService.deleteRecoveryAndSetTaskToDone(this.recovery.id).subscribe(recovery => {
            this.recoveryDeleted.emit();
            this.close();
           });
        }
        modalRef.close();
    });
  }

  deniedRecovery() {
    if ( this.isDeniedButtonDisabled() ) {
      return;
    }
    const modalRef = this.showDeniedRecoveryWarningMessageDialog();
    modalRef.componentInstance.closeModalEvent.subscribe(closedClickingYes => {
      if (closedClickingYes) {
        this.recovery.recoveryStatus = RecoveryStatus.DENIED;
        this.recoveryService.updateRecovery(this.recovery).subscribe(recovery => {
          this.close();
        });
      }
      modalRef.close();
    });
  }

  paymentInAs400ButtonActive(recoveryStatus: RecoveryStatus) : boolean {
    return recoveryStatus !== RecoveryStatus.PAYMENT_IN_AS400 && recoveryStatus !== RecoveryStatus.APPLICATION_SENT;
  }

  cancelRecovery() {
    const modalRef = this.showCancelRecoverylWarningDialog();
    modalRef.componentInstance.closeModalEvent.subscribe(closedClickingYes => {
        if (closedClickingYes) {
          this.recoveryService.cancelRecovery(this.recovery).subscribe(data => {
            this.close();
          });
        }
        modalRef.close();
      }
    );
  }

  paymentInAs400() {
    const modalRef = this.showPaymentInAS400WarningDialog();
    modalRef.componentInstance.closeModalEvent.subscribe(closedClickingYes => {
        if (closedClickingYes) {
          this.recoveryService.paymentInAs400(this.recovery.id).subscribe(data => {
            this.close();
          });
        }
        modalRef.close();
      }
    );
  }

  settleRecovery() {
    const modalRef = this.showSettledWarningDialog();
    modalRef.componentInstance.closeModalEvent.subscribe(closedClickingYes => {
        if (closedClickingYes) {
          this.recoveryService.settleRecovery(this.recovery.id).subscribe(data => {
            this.close();
          });
        }
        modalRef.close();
      }
    );
  }

  getStatusValues(recovery: Recovery): EconomyStatusBarValues {
    const statusValues = !!recovery ? this.getStatusIndexByStatus(recovery?.recoveryStatus, this.recovery.recoveryType) : new EconomyStatusBarValues();
    return statusValues;
  }

  getRedStatusText(recovery: Recovery) {
    if ([RecoveryStatus.CANCELLED].includes(recovery?.recoveryStatus) || [RecoveryStatus.DENIED].includes(recovery?.recoveryStatus)) {
      return recovery?.recoveryStatus;
    }
  }

  onKeyUp(editor) {
    if (this.recovery.description === '') {
      editor.editor.iframeElement.contentDocument.getElementsByTagName('body')[0].style = 'background-color: #fff9e7;';
    } else {
      editor.editor.iframeElement.contentDocument.getElementsByTagName('body')[0].style = 'background-color: #fff';
    }
    this.recalculateRecoveryState();
  }

  onFocus(e: any) {
    // Force a focus-in event, fix for missing focus-in event
    const event = new FocusEvent('focusin', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    const editor = e?.editor?.iframeElement;
    if ( editor ) {
      editor.dispatchEvent(event);
    }
  }

  getSelectableInvoiceNumbers(item: RecoveryViewItem, index: number) {
    if ( !!this.selectableInvoiceNumbers[index] ) {

      return this.selectableInvoiceNumbers[index];
    }
    else {
      if ( this.recoveryType?.businessKey === RecoveryTypeEnum.RT01 ) {
        this.selectableInvoiceNumbers[index] =
          this.invoiceNumbers
            .filter(invoiceItem => item.supplierInvoiceNumber === invoiceItem.id ||
              !this.recoveryItems.find(item => invoiceItem.id === item.supplierInvoiceNumber));
      }

      else if ( this.recoveryType?.businessKey === RecoveryTypeEnum.RT02 ) {
        this.selectableInvoiceNumbers[index] =
        this.invoiceNumbers
            .filter(invoiceItem => item.supplierInvoiceNumber === invoiceItem.id ||
              !this.recoveryItems.find(item => invoiceItem.id === item.supplierInvoiceNumber));

        const selectableRefunds = this.refunds
          .filter(refund => item.refundNumber === refund.id.toString() ||
            !this.recoveryItems.find(item => refund.id.toString() === item.refundNumber))
          .map(refund => new DropdownDictionary(refund.id.toString(), refund.id.toString()));

        this.selectableInvoiceNumbers[index].push(...selectableRefunds);
      }

      else if ( this.recoveryType?.businessKey === RecoveryTypeEnum.RT03 ) {
        this.selectableInvoiceNumbers[index] = [];
        const selectableRefunds = this.refunds
          .filter(refund => item.refundNumber === refund.id.toString() ||
            !this.recoveryItems.find(item => refund.id.toString() === item.refundNumber))
          .map(refund => new DropdownDictionary(refund.id.toString(), refund.id.toString()));

        this.selectableInvoiceNumbers[index].push(...selectableRefunds);
      }

    }
    return this.selectableInvoiceNumbers[index];
  }

  get poaReceivedMissingHoverText() {
    if ( !this.recoveryState.validForReceived ) {
      if (!this.recoveryState.recoveryContextValid) {
        return this.translateService.instant('case-economy-recovery-missing-fields');
      }
      else if (this.getStatusValues(this.recovery).statusIndex >= RecoveryStatusIndex.POA_SIGNED) {
        return this.translateService.instant('case-economy-recovery-already-received');
      }
    }
  }

  get previewApplicationMissingHoverText() {
    if(!this.recovery.id){
        return this.translateService.instant('case-economy-recovery-application-must-be-saved');
    }
    else if ( !this.recoveryState.recoveryValid ) {
      return this.getRecoveryMissingHoverText();
    } else if ( !this.recoveryState.validForPreviewApplication ) {
      if ( !this.recoveryState.recoveryValid || !this.recovery.description || !this.recovery.templateId || !this.recovery.templateLanguage ) {
        if ( !this.recovery.description ) {
          return this.translateService.instant('case-economy-recovery-missing-description');
        }
        else if ( !this.recovery.templateId || !this.recovery.templateLanguage ) {
          return this.translateService.instant('case-economy-recovery-missing-template');
        }
        else {
          return this.translateService.instant('case-economy-recovery-missing-fields');
        }
      }
      else if ( this.getStatusValues(this.recovery).statusIndex <= RecoveryStatusIndex.POA_SIGNED ) {
        return this.translateService.instant('case-economy-recovery-state-not-signed');
      }
    }
    else if ( !this.isAllSelectedInvoicesCharged() ) {
      return this.translateService.instant('case-economy-recovery-invoices-must-be-charged');
    }
  }

  get sendApplicationMissingHoverText() {
    return this.getApplicationMissingHoverText('send');
  }

  get saveApplicationMissingHoverText() {
    return this.getApplicationMissingHoverText('save');
  }

  get AutoCompleteTypeEnum() {
    return AutoCompleteTypeEnum;
  }

  get InputType() {
    return InputType;
  }

  get InputTypePattern() {
    return InputTypePattern;
  }

  get ValidationTypeEnum() {
    return ValidationTypeEnum;
  }

  get RecoveryTypeEnum() {
    return RecoveryTypeEnum;
  }

  get LockContextEnum(): any {
    return LockContextEnum;
  }

  get CaseLockOverlayAction(): any {
    return CaseLockOverlayAction;
  }

  get recoveryStatus(): typeof RecoveryStatus {
    return RecoveryStatus;
  }

  private initialise() {
    this.populateInvoiceDropDownValues();
    this.mergeInvoiceItemsWithLoadedRecoveryItems();
    this.populateRemittanceAdvices();
    this.recalculateRecoveryState();

    setTimeout(() => {
      this.waitBeforeInitTextbox = true;
    }, 500);

    this.createOldRecovery();
  }

  private initialiseReasonForCancellation(caseCreatedDate: string): Observable<ReasonForCancellation[]> {
    return this.masterListService.getReasonForCancellation().pipe(
      tap((result: ReasonForCancellation[]) => {
        const caseCreatedMoment: moment.Moment = !!caseCreatedDate ? DateSerializer.deserialize(caseCreatedDate) : moment();
        this.reasonsForCancellationFilteredByRecoveryType = result.filter(item => this.modalTypeForRecoveryType(item.modalType));
        this.activeReasonsForCancellationOnCreationDate = this.reasonsForCancellationFilteredByRecoveryType.filter(item => !item.activateOn.isAfter(caseCreatedMoment) && (item.deactivateOn === null || !caseCreatedMoment.isAfter(moment(item.deactivateOn)))).map(item => new DropdownDictionary(item.reasonForCancellationCode, item.reasonForCancellationName));
        this.activeReasonsForCancellation = this.reasonsForCancellationFilteredByRecoveryType.filter(item => item.active).map(item => new DropdownDictionary(item.reasonForCancellationCode, item.reasonForCancellationName));
    }));
  }

  private modalTypeForRecoveryType(modalType: string): boolean {
    switch (this.recovery.recoveryType) {
      case RecoveryTypeEnum.RT01:
        return modalType === recoveryModalType.RECOVERY_HEALTH;
      case RecoveryTypeEnum.RT02:
        return modalType === recoveryModalType.RECOVERY_MULTIPLE_INSURANCE;
      case RecoveryTypeEnum.RT03:
        return modalType === recoveryModalType.RECOVERY_TOO_GREAT_TO_CANCEL;
      default:
        return true;
    }
  }

  private validateCustomerProfile() {
    this.caseService.getCustomerProfile(this.customerProfileId.toString()).subscribe(customerProfile =>{
      if(customerProfile.isGroupProfile){
        this.groupMemberValid = false;
      }
      if(customerProfile.profileId) {
        this.getProfileMarket(customerProfile.profileId)
      }
    });
  }

  private getProfileMarket(profileId: string) {
    this.profileService.getProfileMarket(+profileId).subscribe(
      market => this.profileMarket = market
    )
  }

  private save(): Observable<Recovery> {
    this.storingRecovery = true;
    this.recovery.items = this.recoveryItems.filter(item => !!item.isInvoiceItemIncluded);
    if (this.recovery.id === null) {
      return this.recoveryService.createRecovery(this.recovery).pipe(
        tap(() => {
            this.createOldRecovery();
            this.refreshHandlingAreas();
        }),
        finalize(() => this.storingRecovery = false)
      );
    } else {
      return this.recoveryService.updateRecovery(this.recovery).pipe(
        tap(() => {
          this.refreshHandlingAreas();
          this.update.emit();
        }),
        finalize(() => this.storingRecovery = false)
      );
    }
  }

  private refreshHandlingAreas() {
    setTimeout(() => {
      this.caseStateService.sendRefreshHandlingArea();
    }, 200);
  }

  private getRecoveryMissingHoverText() {
    if (!this.recoveryState.recoveryItemsValid) {
      return this.translateService.instant('case-economy-recovery-items-missing-fields');
    } else if (!this.recoveryState.recoveryContextValid) {
      return this.translateService.instant('case-economy-recovery-missing-fields');
    }
    else if (this.totalAppliedAmount() === 0) {
      return this.translateService.instant('case-economy-recovery-applied-amount-must-not-be-nul');
    }
  }

  private getApplicationMissingHoverText(application: string) {
    if (this.recoveryId === null && this.recoveryType?.businessKey === RecoveryTypeEnum.RT03) {
      return this.translateService.instant('case-economy-recovery-application-must-be-saved');
    }
    else if ( !this.recoveryState.applicationHasBeenPreviewed ) {
      return this.translateService.instant('case-economy-recovery-application-must-be-previewed');
    }
    else if ( !this.isAllSelectedInvoicesCharged() ) {
      return this.translateService.instant('case-economy-recovery-invoices-must-be-charged');
    }
    else if ( this.missingMandatoryApplicationFields() ) {
      const missingFields = this.getSendApplicationMissingMandatoryApplicationFields();
      let text = '<span class="send-application-warn"><b>' +
                    this.translateService.instant('case-economy-recovery-missing-mandatory-fields-for-application', {application}) +
                 '</b></span><br>' +
                  Object.keys(missingFields)?.map(supplierInvoiceNumber =>
                    '' + this.translateService.instant('case-economy-recovery-supplier-invoice') + supplierInvoiceNumber +
                    '<ul>' + missingFields[supplierInvoiceNumber]?.map(field => '<li>' + field + '</li>') + '</ul>');
      return text;
    }
  }

  private getSendApplicationMissingMandatoryApplicationFields() {
    const missingFields: {[key: string]: []} = {};

    this.recovery.items.filter((item: RecoveryViewItem) => item.isInvoiceItemIncluded)
                       .map(item => {
      if ( !item.supplierInvoiceKreditor ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-supplier-invoice-creditor-field'));
      }
      if ( !item.supplierPaidAmount ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-supplier-paid-amount-field'));
      }
      if ( !item.supplierPaidAmountBeforeSavings ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-supplier-paid-amount-before-savings-field'));
      }
      if ( !item.appliedAmount ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-applied-amount-field'));
      }
      if ( !item.salesOrderInvoiceNo ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-sales-order-invoice-no-field'));
      }
      if ( !item.serviceItemCode ) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-service-item-code-field'));
      }
      if (!this.swedishOrFinnishRecovery() && this.recovery.recoveryType == RecoveryTypeEnum.RT01 ? !item.remittanceAdviceDocumentId : false) {
        this.addMissingField(missingFields, item.supplierInvoiceNumber, this.translateService.instant('case-economy-recovery-remittance-advice-field'));
      }
    });

    return missingFields;
  }

  private addMissingField(missingFields, key, value) {
    missingFields[key] = (missingFields[key] || []);
    missingFields[key].push(value);
  }

  private missingMandatoryApplicationFields() {
    let  validItems = [];
    const includedItems = this.recovery.items.filter((item: RecoveryViewItem) => item.isInvoiceItemIncluded);
    if(this.recovery.recoveryType === RecoveryTypeEnum.RT01) {
      validItems = includedItems.filter(item => !!item.supplierInvoiceNumber && !!item.supplierInvoiceKreditor && !!item.supplierPaidAmount && !!item.supplierPaidAmountBeforeSavings && !!item.appliedAmount && !!item.salesOrderInvoiceNo && !!item.serviceItemCode && (!this.swedishOrFinnishRecovery ? !!item.remittanceAdviceDocumentId : true));
    } else {
      validItems = includedItems.filter(item =>
          (!!item.supplierInvoiceNumber && !!item.supplierInvoiceKreditor && !!item.supplierPaidAmount && !!item.supplierPaidAmountBeforeSavings && !!item.appliedAmount && !!item.salesOrderInvoiceNo && !!item.serviceItemCode)
          ||
          (!!item.refundNumber && !!item.supplierPaidAmount && !!item.supplierPaidAmountBeforeSavings && !!item.serviceItemCode)
        );
    }
    return validItems.length !== includedItems.length;
  }

  private createOldRecovery() {
    this.oldRecovery = this.getRecoveryCopy();
  }

  private recoveryChanged(): boolean {
    const recovery = this.getRecoveryCopy();
    return JSON.stringify(this.oldRecovery) !== JSON.stringify(recovery);
  }

  private getRecoveryCopy() {
    const clone = _.clone(this.recovery);
    clone.items = _.cloneDeep(this.recoveryItems);
    return clone;
  }

  private invoiceItemsCount(index: number): number {
    let count = 1;
    const firstItem = this.recoveryItems?.length > index ? this.recoveryItems[index] : null;
    if ( !!firstItem ) {
      for (let i = index + 1; i < this.recoveryItems.length; ++i) {
        const item = this.recoveryItems[i] as RecoveryViewItem;
        if ( item.isInvoiceItemGroupStart || item.supplierInvoiceNumber !== firstItem.supplierInvoiceNumber ) {
          break;
        }
        ++count;
      }
    }
    return count;
  }

  private mergeInvoiceItemsWithLoadedRecoveryItems() {
    this.recoveryItems = [this.createRecoveryItem()];
    if ( this.recovery.items?.length > 0 && !!this.recovery.items?.find(item =>!!item.supplierInvoiceNumber || !!item.refundNumber) ) {
      const invoiceNumbers = [...new Set(this.recovery.items?.map(item => item.supplierInvoiceNumber ? item.supplierInvoiceNumber : item.refundNumber))];
      this.recoveryItems = invoiceNumbers.filter(invoiceNumber => !!invoiceNumber).flatMap(invoiceNumber => {
        const itemType = this.itemTypes.get(invoiceNumber);
              let remittanceAdviceDocumentId;
        const recoveryItems = itemType == 'SUPPLIER_INVOICE' ? this.getRecoveryItemsByInvoiceNumber(invoiceNumber)
                                  .map(item => {
                                    const existingItem = this.recovery.items.find(existingItem => existingItem.supplierInvoiceItemId === item.supplierInvoiceItemId);
                                    if (!!existingItem) {
                                      item = new RecoveryViewItem(existingItem);
                                      remittanceAdviceDocumentId = item.remittanceAdviceDocumentId;
                                    }
                                    item.isInvoiceItemIncluded = !!existingItem;
                                    return item;
                                  })
                                  :
                                  this.getRecoveryItemsByRefundNumber(invoiceNumber);


        const existingNotFoundItems = this.recovery.items.filter(item => item.supplierInvoiceNumber === invoiceNumber)
                                                         .filter(existingItem => !recoveryItems.find(item => existingItem.supplierInvoiceItemId === item.supplierInvoiceItemId))
                                                         .map(existingItem => {
                                                            const item = new RecoveryViewItem(existingItem);
                                                            item.isNotFoundWarning = true;
                                                            item.isInvoiceItemIncluded = true;
                                                            return item;
                                                          });
        recoveryItems.push(...existingNotFoundItems);

        recoveryItems.sort((item1: RecoveryViewItem, item2: RecoveryViewItem) => {
          return item1.supplierInvoiceItemId - item2.supplierInvoiceItemId;
        });

        recoveryItems.forEach((item, index) => {
          item.isInvoiceItemGroupStart = index === 0;
          item.remittanceAdviceDocumentId = remittanceAdviceDocumentId;
          item.recoveryItemType = item.supplierInvoiceNumber ? RecoveryViewItemType.SUPPLIER_INVOICE : RecoveryViewItemType.REFUND;
        });
        return recoveryItems;
      });
    } else {
      this.recoveryWithNoItems = true;
    }
  }

  private getRecoveryItemsByRefundNumber(refundNo: string): RecoveryViewItem[] {
    const refund = this.refunds?.find(refund => refund.id.toString() == refundNo);
    return refund.items.map((refundItem, salesOrderItemIndex) =>
      new RecoveryViewItem({
        supplierInvoiceNumber: null,
        refundNumber: refund.id.toString(),
        serviceItemCode: refundItem.serviceItemCode,
        serviceItemName: refundItem.serviceItemCode ? this.serviceItemsForRefund.find(item => item.code == refundItem.serviceItemCode).name : '',
        supplierPaidAmount: refundItem.refundAmount,
        supplierPaidAmountBeforeSavings: refundItem.refundAmount,
        supplierLocalCurrency: refundItem.refundCurrency,
        supplierInvoiceKreditor: null,
        appliedAmount: this.reductionsCalculator.getExchangedNetAmount(refundItem),
        recoveryCurrency: refund.refundCurrency,
        salesOrderInvoiceNo: null,
        serviceOrderId: refundItem.serviceOrderId,
        salesOrderId: this.salesOrders.find(salesOrder => salesOrder.salesOrderItems?.some(item => item.refundItemId === refundItem.id))?.id,
        salesOrderItemId: this.salesOrders?.flatMap(so => so.salesOrderItems).find(item => item.refundItemId === refundItem.id)?.id,
        supplierInvoiceItemId: refundItem.id,
        isInvoiceItemGroupStart: salesOrderItemIndex === 0,
        isInvoiceItemIncluded: true,
      })
    );
  }

  private getRecoveryItemsByInvoiceNumber(invoiceNo: string) {
    const salesOrderTypes = [SalesOrderItemTypeEnum.SUPPLIER_INVOICE];
    const invoice = this.supplierInvoices?.find(supplierInvoice => supplierInvoice.invoiceNumber === invoiceNo);
    const supplierInvoiceItem =
      this.recoveryType.businessKey === RecoveryTypeEnum.RT01 ?
          invoice.items.filter(supplierInvoiceItem =>
            this.serviceItemsForRecovery?.find(serviceItem =>
              serviceItem.code === supplierInvoiceItem?.serviceItemCode
            ))
            :
      invoice.items;
    return supplierInvoiceItem.flatMap((supplierInvoiceItem, supplierInvoiceItemIndex) => {
      const salesOrderItems = this.salesOrders.flatMap(salesOrder => {
        salesOrder.salesOrderItems.forEach(item => item.salesOrderId = salesOrder.id); return salesOrder.salesOrderItems;
      })
      .filter(salesOrderItem =>
        this.serviceOrdersForRecovery.find(serviceOrder => serviceOrder.serviceOrderId === salesOrderItem.serviceOrderId)
      )
      .filter(salesOrderItem =>
        salesOrderTypes.includes(salesOrderItem.type as SalesOrderItemTypeEnum) &&
        salesOrderItem.supplierInvoiceItemId === supplierInvoiceItem.id
      );

      return salesOrderItems.map((salesOrderItem, salesOrderItemIndex) =>
        new RecoveryViewItem({
          supplierInvoiceNumber: invoice.invoiceNumber,
          refundNumber: null,
          serviceItemCode: supplierInvoiceItem.serviceItemCode,
          serviceItemName: supplierInvoiceItem.serviceItemName,
          supplierPaidAmount: salesOrderItem.agreementPrice.amount,
          supplierPaidAmountBeforeSavings: supplierInvoiceItem.paidAmount,
          supplierLocalCurrency: salesOrderItem.agreementPrice.currency,
          supplierInvoiceKreditor: invoice.creditorName,
          appliedAmount: salesOrderItem.invoicePrice.amount,
          recoveryCurrency: salesOrderItem.invoicePrice.currency,
          salesOrderInvoiceNo: this.salesOrders.find(s => s.id === salesOrderItem.salesOrderId)?.invoiceNo,
          serviceOrderId: supplierInvoiceItem.serviceOrderId,
          salesOrderId: salesOrderItem.salesOrderId,
          salesOrderItemId: salesOrderItem.id,
          supplierInvoiceItemId: salesOrderItem.supplierInvoiceItemId,
          isInvoiceItemGroupStart: supplierInvoiceItemIndex === 0 && salesOrderItemIndex === 0,
          isInvoiceItemIncluded: true
         })
      );
    });
  }

  private isAllSelectedInvoicesCharged() {
    if(this.recovery.recoveryType === RecoveryTypeEnum.RT01) {
    const chargedItems = this.recoveryItems
      .filter(item => item.isInvoiceItemIncluded && ![SalesOrderStatus.PAID, SalesOrderStatus.INVOICED].includes(this.salesOrders?.find(salesOrder => salesOrder.id === item.salesOrderId)?.status));
      return chargedItems.length === 0;
    } else {
      return true;
    }
  }

  private populateInvoiceDropDownValues() {
    const invoiceNumbers = this.findAllInvoiceNumbers();
    const existingInvoiceNumbers = this.recovery.items?.map(item => item.supplierInvoiceNumber).
    filter(invoiceNumber => !!invoiceNumber);
    this.invoiceNumbers = [...new Set([...invoiceNumbers, ...existingInvoiceNumbers])].map(invoiceNumber =>
        new DropdownDictionary(invoiceNumber, invoiceNumber)
    );
  }

  private populateRemittanceAdvices() {
    this.remittanceAdvices = this.remittanceDocuments.map(document => new DropdownDictionary(document.id, document.comments));
  }

  private findAllInvoiceNumbers() {
    const salesOrderTypes = [SalesOrderItemTypeEnum.SUPPLIER_INVOICE];
    return this.serviceOrdersForRecovery?.flatMap(serviceOrder => {
      const salesOrderItems = this.salesOrders?.flatMap(salesOrder => salesOrder.salesOrderItems).filter(salesOrderItems => salesOrderTypes.includes(salesOrderItems.type as SalesOrderItemTypeEnum) && salesOrderItems.serviceOrderId === serviceOrder.serviceOrderId);
      return salesOrderItems.flatMap(salesOrderItem => {
        const supplierInvoices = this.recoveryType.businessKey === RecoveryTypeEnum.RT01 ?
          this.supplierInvoices?.filter(supplierInvoice => {
            return supplierInvoice.items.find(supplierInvoiceItem => supplierInvoiceItem.id === salesOrderItem.supplierInvoiceItemId
              && this.serviceItemsForRecovery?.find(serviceItem => serviceItem.code === supplierInvoiceItem?.serviceItemCode));
          })
          :
          this.supplierInvoices?.filter(supplierInvoice => {
            return supplierInvoice.items.find(supplierInvoiceItem => supplierInvoiceItem.id === salesOrderItem.supplierInvoiceItemId);
          });
        return supplierInvoices.map(supplierInvoice => supplierInvoice.invoiceNumber);
      });
    });
  }

  private getRecovery(recoveryId: string): Observable<Recovery> {
    if ( !!recoveryId ) {
      return this.recoveryService.getRecoveryById(+recoveryId);
    }
    else {
      return this.planService.getBillingCurrencyForCase(+this.caseId).pipe(
        map(result => {
          this.billingCurrency = result;
          return this.createRecovery();
        })
      );
    }
  }

  private createRecovery(): Recovery {
    const recovery = new Recovery();
    recovery.caseId = + this.caseId;
    recovery.customerProfileId = + this.customerProfileId;
    recovery.recoveryStatus = this.recoveryType?.businessKey as RecoveryTypeEnum == RecoveryTypeEnum.RT01 ? RecoveryStatus.REQUEST_POA : RecoveryStatus.SEND_APPLICATION;
    recovery.recoveryCurrency = this.billingCurrency?.billingCurrency;
    recovery.internalRemark = '';
    recovery.description = null;
    recovery.id = null;
    recovery.templateName = null;
    recovery.items = [this.createRecoveryItem()];

    return recovery;
  }

  private createRecoveryItem() {
    return new RecoveryViewItem({
      supplierInvoiceNumber: null,
      serviceOrderId: null,
      serviceItemCode: null,
      supplierPaidAmount: null,
      appliedAmount: null,
      recoveredAmount: null,
      isInvoiceItemGroupStart: true,
      isInvoiceItemIncluded: true
    });
  }

  private getStatusIndexByStatus(status: RecoveryStatus, type: RecoveryTypeEnum): EconomyStatusBarValues {
    const statusValues = new EconomyStatusBarValues();
    statusValues.redIconIndex = null;
    statusValues.warnIconIndex = null;
    statusValues.statusIndex = -1;
    Recovery.setStatusIndex(statusValues, status);
    return statusValues;
  }

  private showDeleteRecoveryWarningMessageDialog(): NgbModalRef {
    const confirmCloseDialog = this.modalService.open(ModalDialogComponent);
    confirmCloseDialog.componentInstance.configuration = new ModalDialogConfiguration({
      header: 'default-modal-header',
      title: 'case-economy-recovery-delete-warning-modal-title',
      text: '',
      footer: 'case-economy-recovery-delete-warning-modal-footer',
      yes: 'default-modal-dialog-yes',
      no: 'default-modal-dialog-no',
      isBody: false,
      isFooter: true,
    });
    return confirmCloseDialog;
  }

  private showDeniedRecoveryWarningMessageDialog(): NgbModalRef {
    const confirmCloseDialog = this.modalService.open(ModalDialogComponent);
    confirmCloseDialog.componentInstance.configuration = new ModalDialogConfiguration({
      header: 'default-modal-header',
      title: 'case-economy-recovery-denied-warning-modal-title',
      text: '',
      footer: 'case-economy-recovery-denied-warning-modal-footer',
      yes: 'default-modal-dialog-yes',
      no: 'default-modal-dialog-no',
      isBody: false,
      isFooter: true,
    });
    return confirmCloseDialog;
  }

  private showCancelRecoverylWarningDialog(): NgbModalRef {
    const modalRef = this.modalService.open(ModalDialogComponent);
    modalRef.componentInstance.items = [];
    modalRef.componentInstance.configuration = new ModalDialogConfiguration({
      header: 'default-modal-header',
      title: 'case-economy-recovery-cancel-warning-modal-title',
      text: '',
      footer: 'case-economy-recovery-cancel-warning-modal-footer',
      yes: 'default-modal-dialog-yes',
      no: 'default-modal-dialog-no',
      isBody: false,
      isFooter: true,
    });
    return modalRef;
  }

  private showPaymentInAS400WarningDialog(): NgbModalRef {
    const modalRef = this.modalService.open(ModalDialogComponent);
    modalRef.componentInstance.items = [];
    modalRef.componentInstance.configuration = new ModalDialogConfiguration({
      header: 'case-economy-recovery-as400-warning-modal-title',
      title: 'case-economy-recovery-as400-warning-modal-title',
      text: '',
      footer: 'case-economy-recovery-as400-warning-modal-footer',
      yes: 'default-modal-dialog-yes',
      no: 'default-modal-dialog-no',
      isBody: false,
      isFooter: true,
    });
    return modalRef;
  }

  private showSettledWarningDialog(): NgbModalRef {
    const modalRef = this.showCancelRecoverylWarningDialog();
    modalRef.componentInstance.configuration.title = 'case-economy-recovery-settled-warning-modal-title';
    modalRef.componentInstance.configuration.footer = 'case-economy-recovery-settled-warning-modal-footer';
    return modalRef;
  }

  get tinyMCEConfiguration() {
    let style = '';
    if (this.isDenied()) {
      style = 'body { font-family: calibri; font-size: 11pt; background-color: #bdc7d0; opacity: 0.2;  }';
    } else if (this.recovery.description === '' || this.recovery.description === null) {
      style = 'body { font-family: calibri; font-size: 11pt; background-color: #fff9e7;  }';
    } else {
      style = 'body { font-family: calibri; font-size: 11pt; }';
    }
    return {
      base_url: '/tinymce',
      suffix: '.min',
      menubar: false,
      height: '100%',
      body_class: 'mceBlackBody',
      paste_data_images: true,
      fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 24pt 28pt 32pt 36pt',
      content_style: style,

      font_formats:
        'Calibri=calibri; Arial=arial,helvetica,sans-serif;' +
        'Times New Roman=times new roman,times;' +
        'Helvetica=helvetica;' +
        'Courier New=courier_newregular,courier;' +
        'Verdana=verdana,geneva;',
      plugins: [
        'print preview searchreplace autolink ' +
          'directionality visualblocks visualchars fullscreen image link ' +
          'media template codesample table charmap hr pagebreak nonbreaking ' +
          'anchor toc insertdatetime advlist lists wordcount ' +
          'imagetools textpattern noneditable help ' +
          'charmap quickbars emoticons '
      ],
      toolbar:
        'bold italic underline strikethrough | fontselect fontsizeselect formatselect | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist checklist  | outdent indent | forecolor backcolor formatpainter'
      };
    }

  protected readonly RecoveryStatus = RecoveryStatus;
}

export class RecoveryState {
  recoveryValid = false;
  recoveryContextValid = false;
  recoveryItemsValid = false;
  validForReceived = false;
  validForPreviewApplication = false;
  applicationHasBeenPreviewed = false;
  validForSendApplication = false;
  validToSaveApplication = false;
}
